import { Component, OnInit } from '@angular/core';

import { ContaService } from '../../../../../shared/services/conta/conta.service';
import { CedenteService } from '../../../../../shared/services/cedente/cedente.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';

import { IConta } from '../../../../../shared/interfaces/conta.interface';
import { ICartao } from './../../../../../shared/interfaces/cartao.interface';
import { IEndereco } from '../../../../../shared/interfaces/endereco.interface';
import { ICedente } from '../../../../../shared/interfaces/cedente.interface';
import { IAdquirente } from '../../../../../shared/interfaces/adquirente.interface';

import { Conta } from '../../../../../shared/models/conta';
import { Cartao } from '../../../../../shared/models/cartao';
import { Cedente } from '../../../../../shared/models/cedente';
import { Endereco } from '../../../../../shared/models/endereco';
import { Adquirente } from '../../../../../shared/models/adquirente';
import { LoginService } from '../../../../../shared/services/auth/login/login.service';

@Component({
  selector: 'app-configuracoes',
  templateUrl: './configuracoes.component.html',
  styleUrls: ['./configuracoes.component.scss']
})
export class ConfiguracoesComponent implements OnInit {
  public novoCedente = false;

  public cedentes: ICedente[] = [];
  public adquirentes: IAdquirente[] = [];

  public conta: IConta = new Conta();
  public cartao: ICartao = new Cartao();
  public cedente: ICedente = new Cedente();
  public endereco: IEndereco = new Endereco();
  public adquirente: IAdquirente = new Adquirente();
  public isAdmin = false;

  constructor(
    private contaService: ContaService,
    private cedenteService: CedenteService,
    private localStorage: LocalStorageService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.getAccount();
  }

  getAccount() {
    const loginUser = this.localStorage.get('login');

    if (!loginUser) { return; }

    this.contaService.obterConta(loginUser.PersonId).subscribe((data: any) => {
      this.conta = data;
      this.adquirentes = data.Adquirentes;
      this.cartao = this.cartao && this.conta.Cartoes && this.conta.Cartoes[0] ? this.conta.Cartoes[0] : this.cartao;
      this.endereco = this.endereco && this.conta.Enderecos && this.conta.Enderecos[0] ? this.conta.Enderecos[0] : this.endereco;
      this.getCedentes();
    }, (err) => {
      console.error(err);
    });

    if (this.loginService.isAdmin()) {
      this.isAdmin = true;
    }
  }

  getCedentes() {
    this.cedenteService.obterPorContaId(this.conta.ContaId).subscribe((data: any) => {
      data.forEach((cedente, i, obj) => {
        if (cedente.Padrao && obj.length > 0) {
          const cedenteAux = obj[0];

          obj[0] = cedente;
          obj[i] = cedenteAux;
        }
      });

      this.cedentes = data;
    }, (err) => {
      console.error(err);
    });
  }

  actionNovoCedente() {
    const cedente: ICedente = new Cedente();

    this.cedentes
      .unshift(cedente);
  }

  actionNovoAdquirente() {
    const adquirente: IAdquirente = new Adquirente();

    this.adquirentes
      .unshift(adquirente);
  }

  eventListenerAdquirentes(e) {
    switch (e.name) {
      case 'delete':
        this.getCedentes();
        break;
      case 'default':
        this.adquirentes.forEach((adquirente) => {
          if (adquirente.AdquirenteId === e.id) {
            adquirente.Padrao = true;
          } else {
            adquirente.Padrao = false;
          }
        });
        break;
    }
  }

  eventListenerCedentes(e) {
    switch (e.name) {
      case 'delete':
        this.getCedentes();
        break;
      case 'default':
        this.cedentes.forEach((cedente) => {
          if (cedente.CedenteId === e.id) {
            cedente.Padrao = true;
          } else {
            cedente.Padrao = false;
          }
        });
        break;
    }
  }
}
